// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuex from 'vuex'

import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'


// 引入弹幕插件
import vueBaberrage from 'vue-baberrage'

/*引入jsonp*/
import VueJsonp from 'vue-jsonp'


//mint-ui
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import {MessageBox, Toast, Popup, Actionsheet, CellSwipe, Swipe, SwipeItem,DatetimePicker } from 'mint-ui';



import store from './store/index'
import filters from './plugins/filters'
import LoginData from './plugins/login-data'

import NativeApi from './plugins/native-api'
import logger from './plugins/logger'
import socket from './plugins/net-socket'
import http from './plugins/net-http'
import OwnInfo from './plugins/own-info'
import Preference from "./plugins/preference";
import Device from "./plugins/device";
import RouterPath from "./plugins/router-path";
import AppConfig from "./plugins/config";
import AppUtils from "./plugins/utils";
import Handles from "./plugins/net-socket-handler";
import WebSql from "./plugins/websql";
import NavigateUtil from "./plugins/navigate-util"
import JiaShuJu from "./plugins/jiashuju";

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
  fullscreenEl: false,
};
Vue.use(preview, options)
// var options={
//   fullscreenEl:false //关闭全屏按钮
// }
//
// Vue.use(vuePhotoPreview,options)

Vue.component('mt-cell-swipe', CellSwipe)
Vue.component('mt-swiper', Swipe);
Vue.component('mt-swiper-item', SwipeItem);
Vue.component('mt-popup', Popup);
Vue.component('mt-toast', Toast);
Vue.component('mt-actionsheet', Actionsheet);
Vue.component('mt-message-box', MessageBox);
Vue.component('mt-datetime-picker', DatetimePicker);


Vue.use(VueAwesomeSwiper)

Vue.use(VueJsonp)
Vue.use(vueBaberrage);


Vue.use(VueAxios, axios, vuex)
Vue.use(Mint)
filters(Vue)

Vue.use(AppConfig)
Vue.use(RouterPath)
Vue.use(Preference)
Vue.use(Device)
Vue.use(OwnInfo)
Vue.use(logger)
Vue.use(WebSql)
Vue.use(http)
Vue.use(socket)
Vue.use(Handles)
Vue.use(NativeApi)
Vue.use(LoginData)
Vue.use(AppUtils)
Vue.use(JiaShuJu)
Vue.use(NavigateUtil)

Vue.config.productionTip = false


// 初始化 VConsole
 /*new VConsole()*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js